<template>
  <SlideYUpTransition :duration="animationDuration">
    <<b-modal class="modal fade"
    :hide-footer="!$slots.footer"
        ref="app-modal"
        :size="size"
        :hide-header="!$slots.header"
        :modal-class="computedModalClasses" @mousedown.self="closeModal"
        tabindex="-1"
        role="dialog"
        centered
        @close="closeModal"
        @hide="closeModal"
        :header-class="headerClasses"
        :footer-class="footerClasses"
        :content-class="[
    gradient ? `bg-gradient-${gradient}` : '',
    // Conditionally spread based on type, similar to modalClasses
    ...(Array.isArray(modalContentClasses) ? modalContentClasses : [modalContentClasses])
]"
        :aria-hidden="!show">

      <template v-slot:modal-header>
        <slot name="header"></slot>
            <slot name="close-button">
              <button type="button"
                      class="close"
                      v-if="showClose"
                      @click="closeModal"
                      data-dismiss="modal"
                      aria-label="Close">
                <span :aria-hidden="!show">×</span>
              </button>
            </slot>
      </template>

      <slot />

      <template v-slot:modal-footer>
        <slot name="footer"></slot>
      </template>

    </b-modal>
  </SlideYUpTransition>
</template>
<script>
  import { SlideYUpTransition } from "vue2-transitions";

  export default {
    name: "modal",
    components: {
      SlideYUpTransition
    },
    props: {
      show: Boolean,
      showClose: {
        type: Boolean,
        default: true
      },
      type: {
        type: String,
        default: "",
        validator(value) {
          let acceptedValues = ["", "notice", "mini"];
          return acceptedValues.indexOf(value) !== -1;
        },
        description: 'Modal type (notice|mini|"") '
      },
      modalClasses: {
        type: [Object, String],
        default: () => ({}), // Default to an empty object for flexibility
        description: "Modal dialog css classes"
      },
      size: {
        type: String,
        description: 'Modal size',
        validator(value) {
          let acceptedValues = ["", "sm", "lg"];
          return acceptedValues.indexOf(value) !== -1;
        },
      },
     modalContentClasses: {
  type: [Object, String, Array], // <--- ADDED Array here
  default: () => [],             // <--- Always provide a default empty array for array props
  description: "Modal dialog content css classes"
},
      gradient: {
        type: String,
        description: "Modal gradient type (danger, primary etc)"
      },
      headerClasses: {
        type: [Object, String],
        description: "Modal Header css classes"
      },
      bodyClasses: {
        type: [Object, String],
        description: "Modal Body css classes"
      },
      footerClasses: {
        type: [Object, String],
        description: "Modal Footer css classes"
      },
      animationDuration: {
        type: Number,
        default: 500,
        description: "Modal transition duration"
      }
    },
    computed: {
      // Add a computed property to log the final array being passed to :modal-class
      computedModalClasses() {
        const baseClasses = [{'modal-mini': this.type === 'mini'}];
        let dynamicClasses = [];

        // Determine how to handle modalClasses based on its type
        if (typeof this.modalClasses === 'string') {
          dynamicClasses = [this.modalClasses];
        } else if (typeof this.modalClasses === 'object' && this.modalClasses !== null) {
          // If it's an object (like { 'my-class': true }), Vue's :class can handle it directly.
          // If it's an array, it's also handled.
          // We can just add it as is, and the outer array spread will take care of it
          // OR, if it's an array, we spread it here.
          // For consistency with the spreading logic, we can explicitly convert objects to arrays for spreading.
          dynamicClasses = Array.isArray(this.modalClasses) ? this.modalClasses : [this.modalClasses];
        }

        const finalClasses = [...baseClasses, ...dynamicClasses];
        //console.log('Final modal-class binding array:', finalClasses);
        return finalClasses;
      },
      computedModalContentClasses() {
         // Also add a default for modalContentClasses if it's optional and can be used with spread
         // This helps prevent a similar error if modalContentClasses is undefined
         if (!this.modalContentClasses) return []; // Ensure it's not null/undefined if not passed
         return this.modalContentClasses;
      }
    },
    methods: {
      closeModal() {
        this.$emit("update:show", false);
        this.$emit("close");
      }
    },
    watch: {
      show(val) {
        if (val) {
          //console.log("Modal is now showing. Current modalClasses prop value:", this.modalClasses, "Type:", typeof this.modalClasses);
          this.$refs['app-modal'].show();
        } else {
          //console.log("Modal is now hiding. Current modalClasses prop value:", this.modalClasses, "Type:", typeof this.modalClasses);
          this.$refs['app-modal'].hide();
        }
      },
    
      
    },

   
  };
</script>
<style>
  .modal-backdrop {
    background-color: rgba(0, 0, 0, 0.6) !important;
  }
</style>
